// extracted by mini-css-extract-plugin
export default {"sliderContainer":"ce22ygv9e"};